import createYCloudIcon from '../createYCloudIcon';

/**
 * @component @name MenuOpen
 * @description YCloud SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMyA2aDEzIiAvPgogIDxwYXRoIGQ9Ik0zIDEyaDEwIiAvPgogIDxwYXRoIGQ9Ik0zIDE4aDEzIiAvPgogIDxwYXRoIGQ9Im0yMCA4LTQgNCA0IDQiIC8+Cjwvc3ZnPgo=) - https://tianjianjun0727.github.io/ycloud-icons/icons/menu-open
 * @see https://tianjianjun0727.github.io/ycloud-icons/guide/preact - Documentation
 *
 * @param {Object} props - YCloud icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MenuOpen = createYCloudIcon('menu-open', [
  ['path', { d: 'M3 6h13', key: '1dppxk' }],
  ['path', { d: 'M3 12h10', key: '2cagby' }],
  ['path', { d: 'M3 18h13', key: '1ejobt' }],
  ['path', { d: 'm20 8-4 4 4 4', key: 'dqnig0' }],
]);

export default MenuOpen;
